<template>
  <div class="feed-wrap" ref="context">
    <span class="my-feed" @click="myfeedback">我要反馈</span>
    <a-modal
      centered
      v-model="feedVisible"
      :hasFooter="false"
      :getContainer="getContainer"
      title="我要反馈"
      :customFooter="false"
      width="640px"
      @cancel="closeModal"
    >
      <template>
        <div class="out-line">
          <div class="hidden-frame">
            <a-textarea
              placeholder="欢迎您反馈使用产品过程中遇到的任何问题和建议，最多500字~"
              :rows="20"
              :max-length="500"
              v-model="feedContent"
            />
          </div>
        </div>
      </template>
      <div slot="footer" class="subtn-wrapper ">
        <a-button type="primary" class="ant-btn sub-btn" @click="subFeed">
          提交
        </a-button>
      </div>
    </a-modal>
  </div>
</template>

<script>
// import Modal from '@/components/enroll/Modal.vue'
import { msgTip } from '@/utils/urlUtils'
import { NPOST } from '@/utils/net-work.ts'

export default {
  name: 'feedback',
  props: {
    msg: String,
    value: Boolean
  },
  data() {
    return {
      feedContent: '',
      feedVisible: false
    }
  },
  watch: {
    value: function(val) {
      if (val) {
        this.myfeedback()
      } else {
        this.feedVisible = false
      }
    },
    feedVisible: function(val) {
      if (val) {
        this.feedContent = ''
      }
    }
  },
  methods: {
    myfeedback() {
      window['sensors'].track('Feedback_buttonClick', {})
      this.feedVisible = true
    },
    closeModal() {
      this.feedVisible = false
      this.$emit('close')
    },
    async subFeed() {
      let rdata = await NPOST('/api/user_feedback', {
        content: this.feedContent
      })
      if (rdata.success) {
        this.closeModal()
        msgTip({
          type: 'success',
          msg: rdata.msg || '提交成功'
        })
      } else {
        msgTip({
          type: 'error',
          msg: rdata.error || 'error'
        })
      }
    },
    getContainer() {
      return document.getElementById('topmenu')
    }
  }
}
</script>
<style lang="scss" scoped>
.sub-btn {
  width: 80px;
  height: 40px;
}
.subtn-wrapper {
  // margin: 20px 10px 10px;
  text-align: right;
}
.out-line {
  border: 1px solid $--color-outline;
  border-radius: 4px;
  height: 240px;
  padding: 10px 6px 10px 10px;
  .hidden-frame {
    overflow-y: auto;
    overflow-x: hidden;
    height: 100%;
    width: 100%;
    textarea {
      resize: none;
    }
  }
}
.feed-wrap {
  cursor: pointer;
  position: relative;
  padding-right: 25px;
  display: inline-block;

  .my-feed {
    color: rgba(0, 0, 0, 0.65);
    width: 56px;
    height: 22px;
    font-size: 14px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    line-height: 22px;
  }
  textarea.ant-input {
    border: none;
    &:hover,
    &:active,
    &:focus {
      border: none;
      box-shadow: none;
    }
  }
}
</style>
